import { createContext, ReactNode, useState, useEffect, JSX, useContext } from 'react';

export type Indicator = 'fullScreen' | 'local' | 'custom';

export type DataFetchCtx = {
  isDataFetching: boolean;
  isDataFetchingStickey: boolean;
  loadingMessage?: string;
  indicator?: Indicator;
  setDataFetchingInfo: (
    isFetching: boolean,
    message?: string,
    indicator?: Indicator,
    isDataFetchingStickey?: boolean,
  ) => void;
};

export const DataFetchContext = createContext<DataFetchCtx>({
  isDataFetching: false,
  isDataFetchingStickey: false,
  setDataFetchingInfo: () => {},
});

export const DataFetchProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [isDataFetching, setIsDataFetching] = useState(false);
  const [isDataFetchingStickey, setIsDataFetchingStickey] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState<string>();
  const [indicator, setIndicatorId] = useState<Indicator>();
  const [activeRequests, setActiveRequests] = useState(0);
  const handleSetDataFetching = (
    _isDataFetching: boolean,
    message?: string,
    id?: Indicator,
    _isDataFetchingStickey?: boolean,
  ) => {
    // setIsDataFetching(_isDataFetching);
    setLoadingMessage(message);
    setIndicatorId(id);
    if (_isDataFetchingStickey !== undefined) {
      setIsDataFetchingStickey(_isDataFetchingStickey);
    }
    // Update active requests count
    setActiveRequests((prevCount) => (_isDataFetching ? prevCount + 1 : Math.max(prevCount - 1, 0)));
  };
  useEffect(() => {
    if (activeRequests > 0) {
      setIsDataFetching(true);
    } else {
      setIsDataFetching(false);
    }
  }, [activeRequests]);

  return (
    <DataFetchContext.Provider
      value={{
        isDataFetching,
        loadingMessage,
        indicator,
        isDataFetchingStickey,
        setDataFetchingInfo: handleSetDataFetching,
      }}
    >
      {children}
    </DataFetchContext.Provider>
  );
};

export const useDataFetch = (): DataFetchCtx => useContext(DataFetchContext);
